import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {loadInvitations, loadConnections, approveInvitation} from 'store/actions/connectionsActions'
import Spinner from 'react-bootstrap/Spinner';
import { throttle } from 'lodash'
import {useLocation, useHistory} from 'util/router'
import { apiRequest } from 'util/api/util'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button'
import Avatar from 'react-avatar'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Section from 'components/Section'
import Modal from 'react-bootstrap/Modal'
import NetworkClassesCheckbox from 'components/Connections/NetworkClassesCheckbox'
import {validateEmail} from 'util/auth'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Nav from 'react-bootstrap/Nav'
import InputGroup from 'react-bootstrap/InputGroup'
import SearchIcon from '@material-ui/icons/Search';

function ConnectionItemCard(props) {

    
    const {item} = props
    const {instructor} = item

    const {instructorProfile, widgetName, profileImageUrl, firstName, lastName, id} = instructor;
    const {partnerName, partnerImageUrl} = instructorProfile;

    const viewModel = {
        image: partnerImageUrl ?? profileImageUrl,
        name: partnerName ?? firstName,
        widgetName: widgetName,
        status: item.verified ? "connected" : "invite sent",
        id: id
    }

    // const clickHandler = () => {
    //     console.log("clicked")
    //     if (props.handleRequest) {
    //         props.handleRequest(widget)
    //     }
    // }

    return (
        <Card border='white' className='text-left p-0' style ={{width: '100%'}}>
            <Card.Body className='p-1'>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div className='d-flex flex-row align-items-center'>
                        <Avatar className="mr-2" src={viewModel.image} name={viewModel.name} size={80} round="40px"/>
                        <div>
                            <Card.Title className="m-0 p-0">
                                {viewModel.name}
                            </Card.Title>  
                            <Card.Text className="m-0 p-0 mb-2">
                                {viewModel.widgetName}
                            </Card.Text>
                            {/* <Card.Text className="m-0 p-0 mb-2">
                                {viewModel.id}
                            </Card.Text> */}
                        </div>
                    </div>
                    
                    <div className="ml-2">
                        <span>{viewModel.status}</span>
                        {/* <Button className="" style={{"whiteSpace": "nowrap"}} onClick={clickHandler}>Send Request</Button> */}
                    </div>
                </div>
            </Card.Body>
            <hr />
        </Card>
    )
}

function InvitationItemCard(props) {

    const dispatch = useDispatch()
    const {item} = props
    const {partner} = item

    const {instructorProfile, widgetName, profileImageUrl, firstName, lastName} = partner;
    const {partnerName, partnerImageUrl} = instructorProfile;

    const viewModel = {
        image: partnerImageUrl ?? profileImageUrl,
        name: partnerName ?? firstName,
        widgetName: widgetName,
        status: item.verified ? "connected" : "pending"
    }

    const [isLoading, setIsLoading] = React.useState(false)

    const clickHandler = () => {
        setIsLoading(true)
        dispatch(approveInvitation(item, function() {
            setIsLoading(false)
        }))

        // console.log("clicked")
        // if (props.handleRequest) {
        //     props.handleRequest(item)
        // }
    }

    return (
        <Card border='white' className='text-left p-0' style ={{width: '100%'}}>
            <Card.Body className='p-1'>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div className='d-flex flex-row align-items-center'>
                        <Avatar className="mr-2" src={viewModel.image} name={viewModel.name} size={80} round="40px"/>
                        <div>
                            <Card.Title className="m-0 p-0">
                                {viewModel.name}
                            </Card.Title>  
                            <Card.Text className="m-0 p-0 mb-2">
                                {viewModel.widgetName}
                            </Card.Text>
                        </div>
                    </div>
                    
                    <div className="ml-2">
                        <span>{viewModel.status}</span>
                        {viewModel.status === 'pending' && (
                            <Button disabled={isLoading} className="ml-3" style={{"whiteSpace": "nowrap"}} onClick={clickHandler}>
                                Approve Request
                                {isLoading && (
                                    <Spinner
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden={true}
                                    className="ml-2"
                                    >
                                        {/* <span className="sr-only">Sending...</span> */}
                                    </Spinner>
                                )}
                            </Button>
                        )}
                    </div>
                </div>
            </Card.Body>
            <hr />
        </Card>
    )
}


function WidgetItemCard(props) {

    const {widget} = props

    const {instructorProfile, widgetName, profileImageUrl, firstName, lastName} = widget;
    const {partnerName, partnerImageUrl} = instructorProfile;

    const viewModel = {
        image: partnerImageUrl ?? profileImageUrl,
        name: partnerName ?? firstName,
        widgetName: widgetName
    }

    const clickHandler = () => {
        console.log("clicked")
        if (props.handleRequest) {
            props.handleRequest(widget)
        }
    }

    return (
        <Card border='white' className='text-left p-0' style ={{width: '100%'}}>
            <Card.Body className='p-1'>

                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div className='d-flex flex-row align-items-center'>
                        <Avatar className="mr-2" src={viewModel.image} name={viewModel.name} size={80} round="40px"/>
                        <div>
                            <Card.Title className="m-0 p-0">
                                {viewModel.name}
                            </Card.Title>  
                            <Card.Text className="m-0 p-0 mb-2">
                                {viewModel.widgetName}
                            </Card.Text>
                        </div>
                    </div>
                    
                    <div className="ml-2">
                        <Button className="" style={{"whiteSpace": "nowrap"}} onClick={clickHandler}>Send Request</Button>
                    </div>
                </div>
            </Card.Body>
            <hr />
        </Card>
    )
}

const TooltipTopNavItem = ({title, tooltipMessage, eventKey}) => {
    return (
        <OverlayTrigger
            key={`${eventKey}-bottom`}
            placement={'bottom'}
            overlay={
            <Tooltip id={`tooltip-top`}>
            {tooltipMessage}
            </Tooltip>
            }
        >
            <Nav.Item>
                <Nav.Link eventKey={eventKey}>{title}</Nav.Link>
            </Nav.Item>
        </OverlayTrigger>
    )
  }

function PartnerConnections(props) {

    const [successMessage, setSuccessMessage] = React.useState(null)
    const [errorMessage, setErrorMessage] = React.useState(null)

    const partnerId = useSelector(state => state.instructor.instructor.platformID)
    const widgetName = useSelector(state => state.instructor.instructor.widgetName)
    const user = useSelector(state => state.user.userData)
    const dispatch = useDispatch()

    const [searchTerm, setSearchTerm] = React.useState("");
    const [searchResults, setSearchResults] = React.useState([]);

    const [isSending, setIsSending] = React.useState(false)
    

    const fetchSearchResults = (term) => {
        apiRequest(`connections/searchPartners?widgetName=${term.toLowerCase()}`,"POST")
            .then(results => {
                console.log("search results: ", results)
                const actualResults = results.filter(val => {
                    return val.widgetName && val.widgetName.includes(term.toLowerCase()) && val.id !== partnerId
                })
                setSearchResults(actualResults)
            })
            .catch(err => {
                console.log(err)
                setSearchResults([])
            })
    }

    const handleConnectionRequest = (val) => {
        console.log("connection request")

        apiRequest(`connections/request`, "POST", {
            partnerId: partnerId,
            instructorId: val.id
        })
        .then(response => {
            setSuccessMessage(`Request sent! We've sent an email to ${val.widgetName} 😊`)
            setTimeout(function() {
                setSuccessMessage(null)
            }, 4000)
        })
        .catch(err => {
            setErrorMessage("There was an error sending the request, please try again later")
        })
    }

    const [emailInvite, setEmailInvite] = React.useState("")
    const handleEmailChange = event => {
        setEmailInvite(event.target.value)
    }

    const handleEmailInviteRequest = () => {
        console.log("connection request")

        if (!validateEmail(emailInvite)) {
            window.alert("Please enter valid email address")
            return
        }

        setIsSending(true)
        apiRequest(`connections/request`, "POST", {
            partnerId: partnerId,
            email: emailInvite
        })
        .then(response => {
            setIsSending(false)
            setSuccessMessage(`Request sent! We've sent an email to ${emailInvite} 😊`)
            setTimeout(function() {
                setSuccessMessage(null)
            }, 4000)
        })
        .catch(err => {
            setIsSending(false)
            setErrorMessage("There was an error sending the request, please try again later")
        })
    }

    const handleChange = event => {
        setSearchTerm(event.target.value);
        fetchSearchResults(event.target.value)
    };
    const handleChangeThrottle = throttle(handleChange, 5000)
    React.useEffect(() => {
        // const results = clients.filter(val =>{
        //     if (val.searchTerms) {
        //         for (const term of val.searchTerms) {
        //             if (term && term.includes(searchTerm)) {
        //                 console.log("wahoo")
        //                 return true
        //             }
        //         }
        //     }
        //     return false
        // });
        // setSearchResults([]);
    }, [searchTerm]);

    // const [connections, setConnections] = React.useState(null)
    // const [partners, setPartners] = React.useState(null)
    const connections = useSelector(state => state.connections.connections)
    const partners = useSelector(state => state.connections.partners)
    const isLoading = useSelector(state => state.connections.isLoading)
    // const pendingPartners = useSelector(state => state.connections.pendingPartners)
    React.useEffect(() => {

        if (partnerId) {
            // dispatch(loadInvitations(partnerId))
            dispatch(loadConnections(partnerId))    
        }
    }, [partnerId]);

    const titleFromKey = (key) => {
//         <Tab eventKey="my-instructors" title="Instructors"
// <Tab eventKey="my-partners" title="Partners"
        const keys = {
            "my-instructors": "Instructors",
            "my-partners": "Partners"
        }
        return keys[key] ?? "Settings"
    }
    const location = useLocation();
    const history = useHistory()
    const [key, setKey] = React.useState(location.hash ? location.hash.replace("#", "") : "my-partners");

    const [show, setShow] = React.useState(false)

    return(
    <div className={props.className}>
        <div className='d-flex d-row justify-content-between align-items-center mb-4'>
            <div>
                <h2 className="font-weight-bold">Welcome to Instructor Networks!</h2>
                <h6>My Username:&nbsp;{widgetName ?? ""}</h6>
            </div>
            
            <button onClick={() => {
                    setShow(true)
                }} type="button" className="btn btn-primary">+ Invite New</button>
            {/* <div className="col-md-4 d-flex d-row justify-content">
                
            </div> */}
        </div>

        <Modal size="xl" show={show} onHide={() => {setShow(false)}}>
            <Modal.Header closeButton>
                {/* <Modal.Title>{viewModel.title}</Modal.Title> */}
            </Modal.Header>

            {successMessage && (
                <div className="alert alert-success" role="alert">
                    {successMessage}
                </div>
            )}
            {errorMessage && (
                <div className="alert alert-danger" role="alert">
                    {errorMessage}
                </div>
            )}
            <Modal.Body>
                <div className="mb-5">
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <InputGroup>
                                <InputGroup.Prepend>
                                    <InputGroup.Text>
                                        <SearchIcon  />
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                                <input className="form-control" type="text" placeholder="search by username" aria-label="Search" value={searchTerm} onChange={handleChangeThrottle} />
                                {/* <Form.Control
                                    type="text"
                                    placeholder="Search here.."
                                /> */}
                            </InputGroup>
                            {/* <input className="form-control" type="text" placeholder="search by username" aria-label="Search" value={searchTerm} onChange={handleChangeThrottle} /> */}
                        </div>
                    </div>
                    <div>
                        {searchResults && (
                            searchResults.map(val => {
                                return (
                                    <WidgetItemCard handleRequest={handleConnectionRequest} key={val.id} widget={val} />
                                )
                            })
                        )}
                        <hr></hr>
                        {!searchResults || searchResults.length === 0 && (

                        
                        <div className="d-flex flex-column justify-content-center">
                            <h4 className="mx-auto ">Can't find who you're looking for?</h4>
                            <h6 className="mx-auto mb-4">Invite by email</h6>
                            <input style={{maxWidth: '375px'}} className="form-control mx-auto mb-2" type="email" placeholder="enter email address" aria-label="Search" value={emailInvite} onChange={handleEmailChange} />
                            <button type='button' onClick={() => handleEmailInviteRequest()} disabled={isSending} className="btn btn-primary mx-auto">
                                Send Invite
                                {isSending && (
                                    <Spinner></Spinner>
                                )}
                            </button>
                            {/* <div className="d-flex d-row">
                                
                            </div> */}
                        </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
            
        </Modal>

        {isLoading && (
            <Spinner></Spinner>
        )}

        <Tab.Container
            className={isLoading ? "d-none": ""}
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => {
                history.push(location.pathname + `#${k}`)
                setKey(k)
            }}
            >
            <Nav variant="pills" className="flex-row">
                <TooltipTopNavItem title={'My Partners'} tooltipMessage={'I can add these as an instructor or co-teacher'} eventKey={"my-partners"} />
                <TooltipTopNavItem title={'Featured On'} tooltipMessage={'These people can add me as an instructor or co-teacher'} eventKey={"featured-on"} />
                <TooltipTopNavItem title={'Settings'} tooltipMessage={'Settings'} eventKey={"settings"} />
            </Nav>
                        
            {/* <OverlayTrigger
                placement='bottom'
                overlay={
                <Tooltip id={`tooltip-partners`}>
                    <p className="font-weight-bold mb-5">I can add these as an instructor or co-teacher</p>
                </Tooltip>
                }
            ></OverlayTrigger> */}
            <Tab.Content >
                <Tab.Pane eventKey="my-partners" >
                    <Section className="pt-5">
                        <div className="mb-5">
                            <div>
                                {connections && (
                                    connections.map(val => {
                                        return (
                                            // <></>
                                            <ConnectionItemCard key={val.id} item={val} />
                                        )
                                    })
                                )}
                                {connections?.length === 0 && (
                                    <div className='pt-4 h-100'>
                                        <h4>Invite a friend to teach class so that you can promote it together!</h4>
                                        <h5>Some ways to use instructor networks:</h5>
                                        <ol>
                                            <li><h6>Co-host a themed class together</h6></li>
                                            <li><h6>Co-host an event with another instructor outside of the fitness space to add even more value such as: Nutrition, Baking, Tarot Card Reading etc. </h6></li>
                                            <li><h6>Invite an instructor on your platform to showcase a format you don't regularly teach</h6></li>
                                        </ol>
                                        
                                        <button onClick={() => {
                                            setShow(true)
                                        }} type="button" className="btn btn-primary mt-3">+ Invite New</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Section>
                    
                </Tab.Pane>
                <Tab.Pane eventKey="featured-on" >
                    <Section className="pt-5">
                        <div className="mb-5">
                            <div>
                                {partners && (
                                    partners.map(val => {
                                        return (
                                            // <></>
                                            <InvitationItemCard handleRequest={(e) => {
                                                console.log(e)
                                            }} key={val.id} item={val} />
                                        )
                                    })
                                )}
                            </div>
                        </div>
                    </Section>
                </Tab.Pane>
                <Tab.Pane eventKey="settings" >
                    <Section className="pt-5">
                        {user.platformID && (
                            <NetworkClassesCheckbox user={user} />
                        )}
                    </Section>
                </Tab.Pane>
            </Tab.Content>
            
        </Tab.Container>


        {/* <h2 className="font-weight-bold mb-5">Pending invitations</h2>
        <div className="mb-5">
            <div>
                {pendingPartners && (
                    pendingPartners.map(val => {
                        return (
                            // <></>
                            <InvitationItemCard handleRequest={(e) => {
                                console.log(e)
                            }} key={val.id} item={val} />
                        )
                    })
                )}
            </div>
        </div> */}

        


        



    </div>
    )
}

export function ConnectionsPage(props) {
    return (
        <div className="container">
            <PartnerConnections {...props} />
        </div>
        
    )
}

export default PartnerConnections